module.exports = __webpack_public_path__ + "img/public/AdminIcons/stepIcon.svg?8c9eec5a";